import styles from './Onboarding.module.scss';
import 'swiper/css';

import onboardingVersions from '@/configs/onboarding.json';
import { useStore } from '@/store';
import cn from 'classnames';
import { t } from 'i18next';
import 'swiper/css/pagination';
import { Pagination, Virtual } from 'swiper/modules';
import type { Swiper as SwiperType } from 'swiper/types';

import NextArrow from './images/next-arrow.svg?react';
import { useRef } from 'react';
import { Trans } from 'react-i18next';
import { Swiper, SwiperSlide } from 'swiper/react';

export const Onboarding = () => {
  const {
    pageStore: { setIsOnboardingShown },
    accountStore: { updateAccount },
  } = useStore();

  const onClose = () => {
    setIsOnboardingShown('general', true);
    updateAccount({ onboarding: { general: onboardingVersions.general } });
  };

  const sliderRef = useRef<SwiperType>();

  const onSlideNext = () => {
    if (!sliderRef.current) return;
    sliderRef.current.slideNext();
  };

  return (
    <Swiper
      className={styles.wrapper}
      virtual
      pagination
      modules={[Pagination, Virtual]}
      onReachEnd={onClose}
      onSwiper={(swiper) => {
        sliderRef.current = swiper;
      }}
    >
      <SwiperSlide virtualIndex={0} className={cn(styles.slide, styles.slide7)}>
        <div className={cn(styles.contentBgImage, styles.contentBgImage0)} />
        <div className={styles.content}>
          <h1 className={styles.title}>{t('ASK & EXPLORE')}</h1>
          <p className={cn(styles.subtitle)}>
            <Trans i18nKey="Create your own question. Find out what people really think.">
              1<span>2</span>
            </Trans>
          </p>
          <button className={styles.skip} onClick={onSlideNext}>
            {t('Next')}
          </button>
        </div>
      </SwiperSlide>
      <SwiperSlide virtualIndex={1} className={cn(styles.slide, styles.slide7)}>
        <div className={cn(styles.contentBgImage, styles.contentBgImage6)} />
        <div className={styles.content}>
          <h1 className={styles.title}>{t('CONNECT')}</h1>
          <p className={cn(styles.subtitle)}>
            <Trans i18nKey="Your opinions shape your profile. Match and talk to people who think like you.">
              1<span>2</span>
            </Trans>
          </p>
          <button className={styles.skip} onClick={onSlideNext}>
            {t('Next')}
          </button>
        </div>
      </SwiperSlide>
      <SwiperSlide virtualIndex={2} className={cn(styles.slide, styles.slide1)}>
        <div className={cn(styles.contentBgImage, styles.contentBgImage1)} />
        <div className={styles.content}>
          <h1 className={styles.title}>{t('EARN')}</h1>
          <p className={styles.subtitle}>
            <Trans i18nKey="Vote, predict the crowd, and earn rewards for being right.">
              1<span>2</span>3
            </Trans>
          </p>
          <button className={styles.next} onClick={onSlideNext}>
            {t('Start')}&nbsp;
            <NextArrow className={styles.nextArrow} />
          </button>
        </div>
      </SwiperSlide>
      <SwiperSlide virtualIndex={6} />
    </Swiper>
  );
};
